export default {
	errors: {
		connection: "Erro de conexão com o servidor. Verifique sua internet.",
		server: "Erro interno do servidor. Tente novamente mais tarde.",
		tooManyRequests: "Muitas requisições em pouco tempo. Aguarde um momento.",
		retry: "Tentar novamente",
		timeout: "Tempo limite de conexão excedido. Verifique sua internet.",
	},
};
